import Swal from "sweetalert2";
import i18n from "i18next"; // Import the i18n instance directly

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  customClass: {
    title: "toast-title-text",
  },
});

export const ShowErrorToast = async (
  iconType: any,
  errorCode: any | string | string[],
) => {
  const translatedErrorMessage = i18n.t(errorCode); // Translate the error code

  return Toast.fire({
    icon: iconType || "error",
    title: translatedErrorMessage,
  });
};
